
import React from 'react';
import { AlertTriangle, LogOut } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from '@/components/ui/button';

interface NoCustomersStateProps {
  onLogout: () => void;
}

const NoCustomersState: React.FC<NoCustomersStateProps> = ({ onLogout }) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-muted/40 p-6">
      <div className="w-full max-w-md space-y-6">
        <div className="flex justify-center">
          <AlertTriangle className="h-12 w-12 text-destructive" />
        </div>
        
        <h1 className="text-2xl font-bold text-center">Access Denied</h1>
        
        <Alert variant="destructive" className="border-destructive bg-destructive/10">
          <AlertTitle className="flex items-center gap-2">
            <AlertTriangle className="h-4 w-4" /> 
            No Customer Access
          </AlertTitle>
          <AlertDescription className="mt-2">
            You do not have access to any customers. Please contact your administrator or support team for assistance.
          </AlertDescription>
        </Alert>
        
        <p className="text-sm text-muted-foreground text-center mt-4">
          If you believe this is an error, please check your account permissions or contact support.
        </p>
        
        <Button 
          variant="outline" 
          className="w-full flex items-center justify-center gap-2 mt-4"
          onClick={onLogout}
        >
          <LogOut className="h-4 w-4" />
          <span>Logout</span>
        </Button>
      </div>
    </div>
  );
};

export default NoCustomersState;
